import { ref } from 'vue'

export function createQualityComplaintsState() {
    return {
        complaintTypes: ref([]),
        complaintStatuses: ref([]),
        productionDepartments: ref([]),
        prefetchedComplaint: ref(null)
    }
}
